const Data = [
    {
        "name": "Adeeba Alam Ansari",
        "position": "Sponsorship Head",
        "imageUrl": "/assets/images/members/Heads24/Adeeba ansari.jpg",
        "facebookLink": "https://www.facebook.com/profile.php?id=100087442703521",
        "linkedinLink": "https://www.linkedin.com/in/adeeba-alam-ansari-b3aba1252/",
        "email": "adeeba.ansari@gyws.org"
    },
    {
        name: "Utkarsh",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads24/Utkarsh.jpg",
        facebookLink: "https://m.facebook.com/people/Utkarsh-Chaand/100086954527870/",
        linkedinLink: "https://www.linkedin.com/in/utkarsh-246903274",
        email: "utkarsh@gyws.org"
    },{
        name: "Hemant Kamble",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads24/Hemant Kamble.jpg",
        facebookLink: "https://www.facebook.com/hemant.kamble.9803150?mibextid=kFxxJD",
        linkedinLink: "https://www.linkedin.com/in/hemant-kamble-7b5378229?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        email: "hemant.kamble@gyws.org"
    }, {
        name: "Syed Mehran Ahmed",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads24/Syed Ahmed.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100087564341044",
        linkedinLink: "https://www.linkedin.com/in/syedmehran26",
        email: "syed.ahmed@gyws.org"
    }, {
        name: "Siddhesh Agrawal",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads24/Siddhesh Agrawal.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100086241404924",
        linkedinLink: "https://www.linkedin.com/in/siddhesh-agrawal-3ba110252/",
        email: "siddhesh.agrawal@gyws.org"
    },{
        name: "Nazmi Syed",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads24/Nazmi Syed.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100087177596392&mibextid=ZbWKwL",
        linkedinLink: "https://www.linkedin.com/in/nazmi-syed-63980b269",
        email: "nazmi.syed@gyws.org"
    },
]

export default Data;